import { Dialog } from '../skall/Dialog.tsx';
import { Merkehode } from '../skall/Merke.tsx';

export type Tast = [string, string];

/**
 * DD-11: hele triage-flyten på tastaturet. Kartet er `?`, lukkes med Esc.
 *
 * Dette er INNBOKSENS taster. De virker ikke på Programmer, Kjente feil eller
 * Innstillinger, og et kart som viser dem der ville lyve. Hver side sender sine
 * egne; de globale under legges til av kartet selv.
 */
export const KART: Tast[] = [
  ['j / k', 'neste / forrige sak'],
  ['Enter', 'fokus i detaljen'],
  ['1–3', 'velg lignende sak'],
  ['m', 'slå sammen med valgt sak'],
  ['s, så første bokstav', 'velg neste steg — bokstaven i statusnavnet står på knappen'],
  ['n', 'skriv internt notat'],
  ['o', 'åpne skjermbildet (logges)'],
  ['r', 'skriv svar til innsender'],
  ['a', 'Avvist — åpner svaret med avvisningskode'],
  ['b', 'bekreft kjent feil-lenke'],
  ['f', 'gjør til kjent feil (fra Mottatt)'],
  ['Ctrl+Enter', 'lagre og neste — krever status'],
  ['Ctrl+S', 'lagre — saken blir stående (F29)'],
  ['Esc', 'ut av feltet — tilbake til listetastene; lukker kartet'],
];

/**
 * Tastene som virker uansett hvor du står. Både `g`-akkorden og `?` er bundet i Skall.tsx
 * — begge på window, begge i begge bredder (DD-11 presisert 2026-09-20). De sto tidligere
 * nederst i KART, altså i innboksens liste, og var dermed dokumentert ett sted og
 * virksomme fem.
 *
 * `g o` står bare for eier: Organisasjon finnes ikke i DOM for behandler og leser (DD-01),
 * og et kart som dokumenterte en tast som ikke gjør noe, ville lyve.
 */
export const GLOBALE_TASTER = (eier: boolean): Tast[] => [
  ['g i / g s / g k / g p / g n', 'gå til Innboks / Saker / Kjente feil / Betaprogram / Innstillinger'],
  ...(eier ? ([['g o', 'gå til Organisasjon']] as Tast[]) : []),
  ['?', 'dette kartet'],
];

function Liste({ taster }: { taster: Tast[] }) {
  return (
    <dl className="panel-kart">
      {taster.map(([k, v]) => (
        <div key={k} className="panel-kart-rad">
          <dt>
            <kbd>{k}</kbd>
          </dt>
          <dd>{v}</dd>
        </div>
      ))}
    </dl>
  );
}

/**
 * Kartet er en `Dialog` (skall/Dialog.tsx): fokus inn, fokusfelle, Esc, og sidens taster
 * blokkert. Det var her den logikken først ble skrevet. Skallet eier tilstanden (P4) og
 * sender inn både sidens taster og de globale — de siste avhenger av rollen.
 */
export function Tastaturkart({ tittel, taster, globale, onLukk }: { tittel: string; taster: Tast[]; globale: Tast[]; onLukk: () => void }) {
  return (
    <Dialog tittelId="kart-h" onLukk={onLukk}>
      <Merkehode storrelse="md">
        <h2 id="kart-h" className="panel-h2">
          Tastatur — {tittel}
        </h2>
      </Merkehode>
      {taster.length > 0 ? (
        <>
          <h3 className="panel-h3">På denne siden</h3>
          <Liste taster={taster} />
        </>
      ) : null}
      <h3 className="panel-h3">Overalt</h3>
      <Liste taster={globale} />
      <button type="button" className="panel-knapp-sekundaer" onClick={onLukk} title="Lukk (Esc)">
        Lukk <kbd>Esc</kbd>
      </button>
    </Dialog>
  );
}
